const endpoints = {
    multas:'/multas',
    // exportTeacherList:'/user/teachers/export'
}
export {endpoints}